import { call, put, takeLatest } from 'redux-saga/effects';

import magentoService from '@services/magento.service';

import { actions } from '@store/actions/shipments/package-order';
import { Action, ActionType } from '@store/interfaces/shipments/package-order';

interface AnyResponseInterface {
  [key: string]: any;
}

function* getShipmentPackagesRequest({ payload }: Action) {
  try {
    const params: any = { ...(payload || {}) };
    const dataResponse: AnyResponseInterface = yield call(magentoService.fetchShipmentPendingShipment.bind(magentoService), params);
    yield put(actions.getPackagesSuccess(dataResponse));
    //yield put(actions.clearShipmentDashboardOrdersError());
  } catch (error: any) {
    yield put(actions.getPackagesFailure(error?.message));
  }
}

function* shipmentPackagesSaga() {
  yield takeLatest(ActionType.GET_SHIPMENT_PACKAGE_ORDER_REQUEST, getShipmentPackagesRequest);
}
export default shipmentPackagesSaga;
